module.exports = __webpack_public_path__ + "media/recipes/150-095336c3.png";